import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import './style.scss'
const ProfileSlider = ({ items = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  if (items.length < 3) {
    return <p className="text-center">Need at least 3 items</p>;
  }

  return (
    <Swiper
      modules={[Navigation, Autoplay]}
      spaceBetween={20}
      slidesPerView={3}
      centeredSlides
      loop
      autoplay={{ delay: 3000 }}
      onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
      breakpoints={{
        0: {
          slidesPerView: 1,
          centeredSlides: false,
        },
        768: {
          slidesPerView: 2,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 3,
          centeredSlides: true,
        },
      }}
    >
      {items.map((item, index) => (
        <SwiperSlide key={item.id || index}>
          <div className={`card ${index === activeIndex ? "active" : ""} border-0`}>
            <img
              src={item?.images?.[0]?.name}
              alt={item?.name}
              className="img-fluid"
            />

            {index === activeIndex && (
              <div className="details">
                <h4>{item?.name}</h4>
                <p>{item?.professionArea}</p>
              </div>
            )}
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default ProfileSlider;
